import React, { useState, useEffect } from "react";
import axios from "axios";

const LeadSource = () => {
  const [form, setForm] = useState({
    leadSource: "",
    isActive: true,
  });

  const [sources, setSources] = useState([]);
  const [selected, setSelected] = useState([]);
  const [editId, setEditId] = useState(null); // ✅ Track editing

  // ✅ Fetch all lead sources
  useEffect(() => {
    fetchSources();
  }, []);

 const fetchSources = async () => {
  try {
    const res = await axios.get("https://crm-server-htk6.vercel.app/api/leadSources");

    // 🔹 Sort data alphabetically by 'name' field (case-insensitive)
    const sortedData = [...res.data].sort((a, b) =>
      a.name.localeCompare(b.name, "en", { sensitivity: "base" })
    );

    setSources(sortedData);
  } catch (err) {
    console.error("⚠️ Error fetching lead sources:", err);
  }
};


  // ✅ Handle input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: name === "isActive" ? value === "true" : value,
    });
  };

  // ✅ Save new source
  const handleSave = async () => {
    if (!form.leadSource) {
      alert("⚠️ Please enter Lead Source");
      return;
    }
    try {
      const res = await axios.post("https://crm-server-htk6.vercel.app/api/leadSources", {
        name: form.leadSource,
        isActive: form.isActive,
      });
      if (res.data.success) {
        alert("✅ Lead Source saved successfully");
        fetchSources();
        resetForm();
      }
    } catch (err) {
      console.error("❌ Error saving lead source:", err);
    }
  };

  // ✅ Start editing
  const handleEdit = (src) => {
    setForm({
      leadSource: src.name || src.leadSource,
      isActive: src.isActive === true || src.isActive === "true",
    });
    setEditId(src._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Update source
  const handleUpdate = async () => {
    if (!form.leadSource) {
      alert("⚠️ Please enter Lead Source");
      return;
    }
    try {
      await axios.put(`https://crm-server-htk6.vercel.app/api/leadSources/${editId}`, {
        name: form.leadSource,
        isActive: form.isActive,
      });
      alert("✨ Lead Source updated successfully");
      fetchSources();
      resetForm();
    } catch (err) {
      console.error("❌ Error updating lead source:", err);
    }
  };

  // ✅ Reset form
  const resetForm = () => {
    setForm({ leadSource: "", isActive: true });
    setEditId(null);
  };

  // ✅ Toggle single select
  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  // ✅ Select all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(sources.map((s) => s._id));
    } else {
      setSelected([]);
    }
  };

  // ✅ Delete single
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this Lead Source?")) return;
    try {
      await axios.delete(`https://crm-server-htk6.vercel.app/api/leadSources/${id}`);
      fetchSources();
      setSelected((prev) => prev.filter((s) => s !== id));
    } catch (err) {
      console.error("❌ Error deleting lead source:", err);
    }
  };

  // ✅ Bulk delete
  const handleBulkDelete = async () => {
    if (selected.length === 0) {
      alert("⚠️ Please select at least one lead source to delete");
      return;
    }
    if (!window.confirm(`Delete ${selected.length} selected lead sources?`)) return;

    try {
      await axios.delete("https://crm-server-htk6.vercel.app/api/leadSources", {
        data: { ids: selected },
      });
      setSelected([]);
      fetchSources();
    } catch (err) {
      console.error("❌ Error bulk deleting lead sources:", err);
    }
  };

  return (
    <div className="page" style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>Lead Source Management</h2>

      {/* Form */}
      <div
        className="form-container"
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#264653" }}>
          {editId ? "✏️ Update Lead Source" : "Create New Lead Source"}
        </h3>

        <div
          className="form-row"
          style={{ display: "flex", gap: "10px", marginBottom: "10px" }}
        >
          <input
            type="text"
            name="leadSource"
            placeholder="Lead Source"
            value={form.leadSource}
            onChange={handleChange}
            style={{ flex: 2, padding: "8px" }}
          />
          <select
            name="isActive"
            value={form.isActive}
            onChange={handleChange}
            style={{ flex: 1, padding: "8px" }}
          >
            <option value={true}>Active</option>
            <option value={false}>Inactive</option>
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={editId ? handleUpdate : handleSave}
            style={{
              background: editId ? "#e9c46a" : "#2a9d8f",
              color: "white",
              padding: "10px 16px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              flex: 1,
            }}
          >
            {editId ? "✏️ Update Lead Source" : "💾 Save Lead Source"}
          </button>

          {editId && (
            <button
              onClick={resetForm}
              style={{
                background: "#e63946",
                color: "white",
                padding: "10px 16px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                flex: 1,
              }}
            >
              ❌ Cancel
            </button>
          )}
        </div>
      </div>

      {/* List Header with Bulk Delete */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h3 className="list-title" style={{ margin: 0 }}>📋 Lead Source List</h3>
        <button
          onClick={handleBulkDelete}
          style={{
            background: selected.length > 0 ? "#e63946" : "gray",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: selected.length > 0 ? "pointer" : "not-allowed",
          }}
          disabled={selected.length === 0}
        >
          🗑 Delete Selected ({selected.length})
        </button>
      </div>

      {/* Table */}
      <div className="table-container" style={{ overflowX: "auto" }}>
        <table className="user-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f4f4f4" }}>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={sources.length > 0 && selected.length === sources.length}
                />
              </th>
              <th>Lead Source</th>
              <th>Is Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sources.length === 0 ? (
              <tr>
                <td colSpan="4" style={{ textAlign: "center", padding: "12px" }}>
                  No Lead Sources Found
                </td>
              </tr>
            ) : (
              sources.map((s) => (
                <tr key={s._id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={selected.includes(s._id)}
                      onChange={() => toggleSelect(s._id)}
                    />
                  </td>
                  <td>{s.name || s.leadSource}</td>
                  <td>{s.isActive ? "Yes" : "No"}</td>
                  <td style={{ textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <button
                        onClick={() => handleEdit(s)}
                        style={{
                          background: "#457b9d",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        ✏️ Edit
                      </button>
                      <button
                        onClick={() => handleDelete(s._id)}
                        style={{
                          background: "#e63946",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        🗑 Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeadSource;
